/* eslint-disable i18next/no-literal-string */
import { type FC } from 'react';

import { PageType } from '@vgtv/api-client/lib/page';

import { AssetsGallery } from '../../components/AssetsGallery/AssetsGallery';
import { PageMetadata } from '../../components/PageMetadata/PageMetadata';
import { usePageViewTracking } from '../../components/utils/usePageViewTracking';
import { getSlug } from '../../shared/helpers/getSlug';
import { getPath, routeNames } from '../../shared/helpers/routes';

import { Box } from './Box';
import { Card } from './Card';
import { appsContent } from './Cards/Apps';
import { castingContent } from './Cards/Casting';
import { donglesContent } from './Cards/Dongle';
import { FeedbackButtons } from './FeedbackButtons/FeedbackButtons';

import * as styles from './BigScreenLandingPage.module.scss';

const entity = { slug: getSlug(getPath(routeNames.bigScreen)) };
const overrides = {
  title: 'Få den beste TV-opplevelsen',
};

const LandingPage: FC = () => {
  usePageViewTracking({
    pageType: PageType.CUSTOM,
    entity,
  });

  return (
    <>
      <PageMetadata
        pageType={PageType.CUSTOM}
        entity={entity}
        overrides={overrides}
      />
      <AssetsGallery className={styles.background} />
      <div className={styles.root}>
        <Box>
          <h1>Få den beste TV-opplevelsen</h1>
        </Box>
        <Box>
          Last ned vår nye Android TV-app for å se dine VGTV-favoritter på
          storskjerm.
        </Box>
        <Card content={appsContent} />
        <Box>
          <div>
            Det er mange måter å se innholdet fra VGTV på TV-en sin, vi har
            samlet de vanligste tilkoblingsmulighetene i en guide her.
          </div>
        </Box>
        <Card content={donglesContent} />
        <Card content={castingContent} />
        <Box withBackground>
          <h2>Fikk du hjelpen du trengte?</h2>
          <FeedbackButtons />
        </Box>
      </div>
    </>
  );
};

export { LandingPage };
